import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: {
      title: '產品系列',
      links: [
        { label: '經典系列', href: '/category/classic' },
        { label: '尊享系列', href: '/category/premium' },
        { label: '伴侶系列', href: '/category/couple' },
        { label: '日常養護系列', href: '/category/daily' },
      ],
    },
    support: {
      title: '客戶服務',
      links: [
        { label: '常見問題', href: '/articles' },
        { label: '使用指南', href: '/articles' },
        { label: '訂購諮詢', href: '/about#contact' },
        { label: '防偽查詢', href: '/about' },
      ],
    },
    about: {
      title: '關於我們',
      links: [
        { label: '品牌故事', href: '/about' },
        { label: '研發實力', href: '/about#research' },
        { label: '聯繫我們', href: '/about#contact' },
        { label: '健康資訊', href: '/articles' },
      ],
    },
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-4">性福寶</h3>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              專為追求高品質親密生活的人群研發，採用天然精華配方，幫助提升活力與自信，讓每一刻都充滿幸福感。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 cursor-pointer hover:bg-primary-600 hover:text-background-50 transition-colors">
                <i className="ri-mail-line text-lg"></i>
              </span>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-medium text-sm text-background-200 mb-4 uppercase tracking-wide">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 性福寶官方網站 版權所有
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 whitespace-nowrap">隱私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 whitespace-nowrap">使用條款</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 whitespace-nowrap">退換政策</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;